import { useMemo } from 'react'

import { useCompanyUsers, useCurrentUserCompany } from './api'

type UseCurrentCompanyOptions = {
  includeMembers?: boolean
  membersLimit?: number
  membersOffset?: number
}

export const useCurrentCompany = (options?: UseCurrentCompanyOptions) => {
  const includeMembers = options?.includeMembers ?? false
  const membersLimit = options?.membersLimit ?? 50
  const membersOffset = options?.membersOffset ?? 0

  const companyQuery = useCurrentUserCompany()
  const companyId = companyQuery.data?.id ?? ''

  const membersQuery = useCompanyUsers(
    { id: companyId, limit: membersLimit, offset: membersOffset },
    { enabled: includeMembers && !!companyId }
  )

  return useMemo(
    () => ({
      company: companyQuery.data,
      companyLoading: companyQuery.isLoading,
      companyError: companyQuery.error,
      refetchCompany: companyQuery.refetch,
      members: membersQuery.data?.data ?? [],
      membersTotal: membersQuery.data?.total ?? 0,
      membersLoading: membersQuery.isLoading,
      membersError: membersQuery.error,
      refetchMembers: membersQuery.refetch,
    }),
    [
      companyQuery.data,
      companyQuery.isLoading,
      companyQuery.error,
      companyQuery.refetch,
      membersQuery.data,
      membersQuery.isLoading,
      membersQuery.error,
      membersQuery.refetch,
    ]
  )
}
